<div class="card widget-card">
  <div class="card-body">
    <i *ngIf="!showSelect" class="fa fa-th pull-left" cdkDragHandle></i>
    <i *ngIf="!showSelect" class="fa fa-arrow-right pull-right" (click)="navigateToList()"></i>
    <h5 *ngIf="!showSelect" class="card-title text-center">{{model.DisplayName}}</h5>
    <spk-checkbox *ngIf="showSelect" [class]="'pull-left'" [wrapped]="false" name="selected{{model.Id}}" [label]="''" [(model)]="model.Selected"></spk-checkbox>
    <h5 *ngIf="showSelect" class="card-title text-center">{{model.DisplayName}}</h5>
    <p class="count-text text-center">{{model.Count}}</p>
  </div>
</div>
